import React from 'react'
import CustomTable from '../Table/CustomTable'
import CustomTableHeading from '../Table/CustomTableHeading'
import CustomTableRow from '../Table/CustomTableRow'
import ActionIcon2 from '../ActionIcon2'
import { makeStyles, TableBody, TableCell } from '@material-ui/core'
import CustomDialog from '../CustomDialog'
import SubCategoryForm from '../Forms/SubCategory/SubCategoryForm'
import { StoresCatalogue } from '../Forms/Stores/StoresCatalogue'

const useStyles = makeStyles((theme) => ({
  select: {
    width: '383px',
    height: '30px',
    left: '409px',
    top: '108px',
    background: '#F6F8FE',
    float: 'left',
    margin: 5,
  },
}))

export const Stores = () => {
  const classes = useStyles()

  const [open, setOpen] = React.useState(false)
  const handleOpen = () => setOpen(true)
  const handleClose = () => setOpen(false)

  const handleEditOpen = () => {}
  const handleDeleteOpen = () => {}
  return (
    <div>
      <select variant="outlined" name="" id="" className={classes.select}>
        <option value="">East</option>
        <option value="">West</option>
        <option value="">Nort</option>
        <option value="">South</option>
      </select>
      <button style={{ float: 'right', margin: 5 }} onClick={handleOpen}>
        +
      </button>
      <CustomTable>
        <CustomTableHeading heading={['State', 'City', 'Store Name', 'adress', 'No. of Employess', 'Action']} />
        <TableBody>
          <CustomTableRow>
            <TableCell>Maharashtra</TableCell>
            <TableCell>Mumbai</TableCell>
            <TableCell>Lifestyle Stores</TableCell>
            <TableCell>No 142, Phoenix Market City, Velachery Rd</TableCell>
            <TableCell>20</TableCell>
            <TableCell>
              <ActionIcon2 dialog1={handleEditOpen} dialog2={handleDeleteOpen} />
            </TableCell>
          </CustomTableRow>
          <CustomTableRow>
            <TableCell>Tamil Nadu</TableCell>
            <TableCell>Chennai</TableCell>
            <TableCell>Vasanth & co</TableCell>
            <TableCell>No 57, mettu street, villangadupakkam</TableCell>
            <TableCell>40</TableCell>
            <TableCell>
              <ActionIcon2 dialog1={handleEditOpen} dialog2={handleDeleteOpen} />
            </TableCell>
          </CustomTableRow>
          <CustomTableRow>
            <TableCell>Maharashtra</TableCell>
            <TableCell>Pune</TableCell>
            <TableCell>City Light General Store</TableCell>
            <TableCell>Mumbai, Maharashtra · In R City Mall</TableCell>
            <TableCell>30</TableCell>
            <TableCell>
              <ActionIcon2 dialog1={handleEditOpen} dialog2={handleDeleteOpen} />
            </TableCell>
          </CustomTableRow>
          <CustomTableRow>
            <TableCell>Karnataka</TableCell>
            <TableCell> Bangalore</TableCell>
            <TableCell>Mantri Square </TableCell>
            <TableCell>Bengaluru, Karnataka</TableCell>
            <TableCell>40</TableCell>
            <TableCell>
              <ActionIcon2 dialog1={handleEditOpen} dialog2={handleDeleteOpen} />
            </TableCell>
          </CustomTableRow>
        </TableBody>
      </CustomTable>

      <CustomDialog open={open} handleClose={handleClose}>
        <StoresCatalogue handleClose={handleClose} />
      </CustomDialog>
    </div>
  )
}
